import { render } from "./MatchPairExerciseComponent.vue?vue&type=template&id=d06d0d8a&scoped=true"
import script from "./MatchPairExerciseComponent.vue?vue&type=script&lang=js"
export * from "./MatchPairExerciseComponent.vue?vue&type=script&lang=js"

import "./MatchPairExerciseComponent.vue?vue&type=style&index=0&id=d06d0d8a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d06d0d8a"]])

export default __exports__